import SwitchCard from './SwitchCard';

export default SwitchCard;
